// Copyright 2026 AllSpice. All rights reserved.

import type {PreviewableTreeNode} from '../types/file_tree.ts';

/**
 * Extract the parent file's nameHash from a page-level nameHash.
 * Page nameHashes follow the pattern `{parentHash}_{pageId}`.
 */
export function getParentHash(pageNameHash: string): string {
  return pageNameHash.split('_')[0];
}

/**
 * Check if a file node is a child of a multi-page schematic by looking up
 * its parent in the hashToPathMap.
 */
export function isMultiPageSchematic(pageNameHash: string, hashToPathMap: Map<string, PreviewableTreeNode>): boolean {
  const parent = hashToPathMap.get(getParentHash(pageNameHash));
  return parent?.ty === 'multi-page-diff';
}
